import { useEffect, useState } from 'react';

import lang from '../../../lib/language';
import { ChartDataRange, ChartDataSet } from '../../../lib/store/market-data/charting/types';
import TradePriceCache from '../../../lib/store-util/TradePriceCache';
import { useLineClose } from '../../../lib/util/hooks/TradingDataHooks';
import { NullableNumber } from '../../../lib/util/types';

import Button from '../../../shared_components/Button/Button';
import { ButtonTypesEnum } from '../../../shared_components/Button/Button.types';
import { CanvasChart } from '../../../shared_components/CanvasChart';

import styles from './ChartContainer.module.scss';

type Props = {
  dataSet?: ChartDataSet;
  symbol: string;
  range: ChartDataRange;
  hasNoData: boolean;
  handleBtnRetry: () => void;
  isEuroStock?: boolean;
  isCrypto?: boolean;
  companyName?: string;
}

export const ChartContainer = ({
  dataSet,
  symbol,
  range,
  hasNoData,
  handleBtnRetry,
  isEuroStock = false,
  isCrypto = false,
  companyName,
}: Props) => {
  const [isRetryLoading, setIsRetryLoading] = useState<boolean>(false);
  const [lineClose, setLineClose] = useState<NullableNumber>(TradePriceCache.get(symbol)?.priceData.lineClose);
  useLineClose(symbol, lineClose, setLineClose, 'SymbolDetails/ChartContainer');

  useEffect(() => {
    const tradePrice = TradePriceCache.get(symbol);
    setLineClose(tradePrice?.priceData.lineClose);
  }, [symbol]);

  const showNoData = !dataSet?.lineData.length || !lineClose || !dataSet?.isValid;

  if (showNoData) {
    return (
      <div className={styles.noData} style={{ flexDirection: 'column' }}>
        {isRetryLoading ? lang.commonMessageLoading() : lang.commonMessageNoData()}
        {!isRetryLoading && (
          <Button
            variant={ButtonTypesEnum.Link}
            onClick={() => {
              setIsRetryLoading(true);
              handleBtnRetry();
              setTimeout(() => {
                setIsRetryLoading(false);
              }, 1000);
            }}
          >
            {lang.commonWatchlistRetry()}
          </Button>
        )}
      </div>
    );
  }

  return (
    <div className={styles.rootContainerStyle}>
      <CanvasChart
        dataSet={dataSet}
        range={range}
        isEuroStock={isEuroStock}
        isCrypto={isCrypto}
        lineClose={lineClose}
        symbol={symbol}
        companyName={companyName}
      />
    </div>
  );
};
